import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(2),
        padding: theme.spacing(4),
        overflowX: 'auto',
    },
    organizationExpansionPanel: {
        display: 'block'
    },
    downloadReportButton: {
        padding: '5px',
        fontSize: '11px'
    },
    notificationSpan: {
        float: 'right',
        color: 'red',
        paddingTop: '10px'
    },
}))
